import { bindRequestLogic } from './utils'
import RolesConfigurationTypes from '../actionTypes/rolesConfiguration'
import { rolesConfigurationAPI } from '../api'

const getRolesConfiguration = bindRequestLogic({
  clientFunc: rolesConfigurationAPI.getRolesConfiguration,
  type: RolesConfigurationTypes.GET_ROLES_CONFIGURATION_REQUEST,
  successType: RolesConfigurationTypes.GET_ROLES_CONFIGURATION_SUCCESS,
  failType: RolesConfigurationTypes.GET_ROLES_CONFIGURATION_FAILED,
  isQueryParam: true
})

const updateRolesConfiguration = bindRequestLogic({
  clientFunc: rolesConfigurationAPI.updateRolesConfiguration,
  type: RolesConfigurationTypes.UPDATE_ROLES_CONFIGURATION_REQUEST,
  successType: RolesConfigurationTypes.UPDATE_ROLES_CONFIGURATION_SUCCESS,
  failType: RolesConfigurationTypes.GET_ROLES_CONFIGURATION_FAILED
})

const getAllowedRoleManage = bindRequestLogic({
  clientFunc: rolesConfigurationAPI.getAllowedRoleManage,
  type: RolesConfigurationTypes.GET_ALLOWED_ROLE_MANAGE_REQUEST,
  successType: RolesConfigurationTypes.GET_ALLOWED_ROLE_MANAGE_SUCCESS,
  failType: RolesConfigurationTypes.GET_ALLOWED_ROLE_MANAGE_FAILED,
  isQueryParam: true
})

const updateAllowedRoleManage = bindRequestLogic({
  clientFunc: rolesConfigurationAPI.updateAllowedRoleManage,
  type: RolesConfigurationTypes.UPDATE_ALLOWED_ROLE_MANAGE_REQUEST,
  successType: RolesConfigurationTypes.UPDATE_ALLOWED_ROLE_MANAGE_SUCCESS,
  failType: RolesConfigurationTypes.UPDATE_ALLOWED_ROLE_MANAGE_FAILED
})

export default [
  getRolesConfiguration,
  updateRolesConfiguration,
  getAllowedRoleManage,
  updateAllowedRoleManage
]
